import { render } from "./VerticalQuantityControl.vue?vue&type=template&id=bb6c10d2&scoped=true&ts=true"
import script from "./VerticalQuantityControl.vue?vue&type=script&lang=ts"
export * from "./VerticalQuantityControl.vue?vue&type=script&lang=ts"

import "./VerticalQuantityControl.vue?vue&type=style&index=0&id=bb6c10d2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb6c10d2"]])

export default __exports__